import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Typography, Checkbox } from '@mui/material';
import { UPLOAD_STATES } from '../../redux/reducers/ui';
import {
  uploadTagsAction,
  uploadTagPointTypeAssociationAction,
  uploadTagEquipmentTypeAssociationAction,
} from '../../redux/actions/tags';
import UploadView from './UploadView';

const TagUploadForm = ({
  variant,
  uploadState,
  submitPointTypeAssociation,
  submitTags,
  submitEquipmentTypeAssociation,
}) => {
  const [file, setFile] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [allowNew, setAllowNew] = useState(false);
  const onSubmit = (event) => {
    event.preventDefault();
    if (file === null) return;
    let handler;
    if (variant === 'tagPointType') {
      handler = submitPointTypeAssociation;
    } else if (variant === 'tagEquipmentType') {
      handler = submitEquipmentTypeAssociation;
    } else {
      // tagCreate
      handler = submitTags(allowNew);
    }
    handler(file).catch((e) => setErrorMsg(e.message));
  };
  return (
    <div>
      {variant === 'tagCreate' && (
        /*  eslint-disable-next-line jsx-a11y/label-has-associated-control */
        <label>
          This CSV contains new tags
          <Checkbox checked={allowNew} onChange={(e) => setAllowNew(e.target.checked)} />
        </label>
      )}
      <UploadView
        selectedFileName={file?.name}
        onFormSubmit={onSubmit}
        onFileSelection={(e) => {
          e.preventDefault();
          if (e.target.files.length !== 1) return;
          setFile(e.target.files[0]);
        }}
        showUploadButton={file != null}
        isLoading={uploadState === UPLOAD_STATES.PROCESSING}
        uploadDisabled={uploadState === UPLOAD_STATES.PROCESSING}
        errorMsg={errorMsg}
      />
      {uploadState === UPLOAD_STATES.SUCCESS && (
        <div>
          <Typography>Success!</Typography>
        </div>
      )}
    </div>
  );
};

export default connect(
  ({ ui: { uploadState } }) => ({ uploadState }),
  (dispatch) => ({
    submitTags: (allowNew) => (file) => dispatch(uploadTagsAction(file, allowNew)),
    submitPointTypeAssociation: (file) => dispatch(uploadTagPointTypeAssociationAction(file)),
    submitEquipmentTypeAssociation: (file) =>
      dispatch(uploadTagEquipmentTypeAssociationAction(file)),
  })
)(TagUploadForm);
